'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = template;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash.omit');

var _lodash2 = _interopRequireDefault(_lodash);

var _index = require('../style/index');

var _index2 = _interopRequireDefault(_index);

var _reactTransitionGroup = require('react-transition-group');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function template() {
    var animationItems = null,
        attrs = void 0,
        classList = this.compileStyle(_index2.default);

    if (this.state.animationItems.length) {
        animationItems = [];

        this.state.animationItems.forEach(function (item) {
            animationItems.push(_react2.default.createElement(
                _reactTransitionGroup.CSSTransition,
                {
                    classNames: classList.animation,
                    timeout: { enter: 2000 },
                    exit: false,
                    key: item.key
                },
                _react2.default.createElement('div', { className: classList.animation, style: { top: item.top + 'px', left: item.left + 'px' } })
            ));
        });
    }

    // all attributes, exclude components one, goes to button attributes
    attrs = (0, _lodash2.default)(this.props, ['primary', 'secondary', 'warning', 'error', 'primaryInversion', 'flat', 'flatPrimary', 'tag', 'tagPrimary', 'theme', 'square', 'multiline', 'rounded', 'circle']);

    return _react2.default.createElement(
        'div',
        { className: classList.root + ' ' + (this.props.className || '') },
        _react2.default.createElement(
            'button',
            _extends({}, attrs, {
                onClick: this._handleClick.bind(this),
                onMouseEnter: this._handleMouseEnter.bind(this),
                onMouseLeave: this._handleMouseLeave.bind(this),
                className: classList.field,
                ref: this._createRef.bind(this)
            }),
            this.props.children,
            _react2.default.createElement(
                _reactTransitionGroup.TransitionGroup,
                {
                    component: 'div',
                    className: classList.animationContainer
                },
                animationItems
            )
        )
    );
}